export const videoPromotion = {
  _title: 'Promotion vidéos',
  promotionOperations: 'Opérations de promotion',
  newOperation: 'Nouvelle opération',
  configurationType: 'Type de configuration',
  createdBy: 'Lancée par',
  infocards: 'Infocards',
  videoName: 'Nom de la vidéo',
  videoId: 'Identifiant de la vidéo',
  playlistName: 'Nom de la playlist',
  noPlaylist:
    'Aucune playlist connue pour cette chaîne : synchronisez ses vidéos pour les récupérer',
  hasEndscreen: 'Présence Endscreen',
  syncChannelVideos: 'Synchroniser les vidéos de la chaîne',
  syncModal: {
    description: 'Les vidéos publiques de la chaîne seront synchronisées depuis YouTube.',
    latestVideos: 'Les 200 dernières vidéos',
    fullResync: 'Toutes les vidéos de la chaîne',
    fullResyncWarning:
      'La resynchronisation complète relit toutes les vidéos de la chaîne : elle peut être longue et coûteuse en quota YouTube sur les grosses chaînes.',
    includeUnlisted: 'Inclure les vidéos non répertoriées et privées',
    includeUnlistedWarning:
      'Cette recherche consomme beaucoup de quota YouTube : à utiliser seulement si une vidéo manque.',
    sync: 'Synchroniser',
  },
  selectYoutubeChannelToList: 'Veuillez sélectionner une chaîne YouTube pour lister des vidéos',
  selectedVideo_one: 'vidéo sélectionnée',
  selectedVideo_other: 'vidéos sélectionnées',
  noVideoSelected: 'Aucune vidéo sélectionnée',
  deselectAll: 'Tout désélectionner',
  selectAllMatching:
    'Sélectionner la vidéo correspondant aux filtres |||| Sélectionner les %{smart_count} vidéos correspondant aux filtres',
  selectAllMatchingConfirm:
    'La vidéo correspondant aux filtres actuels sera ajoutée à la sélection. |||| Les %{smart_count} vidéos correspondant aux filtres actuels seront ajoutées à la sélection.',
  selectAllTooMany:
    '%{smart_count} vidéos correspondent aux filtres : affinez la recherche pour en sélectionner au plus %{max} à la fois',
  displayedTitle: 'Titre affiché',
  displayedAt: 'Apparaît à',
  sourceVideo: 'Vidéo source',
  targetVideo: {
    search: 'Rechercher',
    byId: 'ID ou URL',
    idOrUrl: 'ID ou URL de la vidéo YouTube',
    invalidId: "Ce n'est pas un identifiant ni une URL de vidéo YouTube",
    notFound: 'Vidéo introuvable sur YouTube',
    notPublic: "Cette vidéo n'est pas publique (%{status}) : YouTube peut refuser de la cibler",
  },
  statuses: {
    pending: 'En attente',
    running: 'En cours',
    completed: 'Terminé',
    failed: 'Échoué',
    success: 'Réussi',
    skipped: 'Ignoré',
    unknown: 'Inconnu',
  },
  operationSteps: {
    0: 'Sélection des vidéos',
    1: 'Configuration des éléments',
    2: 'Confirmation',
  },
  operationStepsTooltips: {
    0: 'Au moins 1 vidéo doit être sélectionnée',
    1: 'Configurez au moins un élément à appliquer',
    2: '',
  },
  endScreen: {
    _title: 'Écran de fin',
    layout: 'Layout',
    positions: 'Emplacements',
    parameters: 'Paramètres',
    slotLabel: 'Emplacement',
    slotTypePlaceholder: 'Choisir un élément',
    slotTypes: {
      videoFixed: 'Vidéo précise',
      recentUpload: 'Vidéo la plus récente',
      bestForViewer: 'Meilleure pour le spectateur',
      playlist: 'Playlist',
      channel: 'Chaîne',
      subscribe: "S'abonner",
    },
    startSecondsBeforeEnd: "Début de l'écran de fin",
    secondsBeforeEnd: 'sec. avant la fin',
    durationSeconds: "Durée d'affichage",
    defaultValueSeconds: 'Valeur par défaut: 20 sec avant la fin',
    configs: {
      copyEndscreen: {
        title: "Copier l'endscreen d'une vidéo",
        description:
          'Les emplacements et les éléments sélectionnés seront copiés depuis la vidéo sélectionnée ci-dessous',
      },
      chooseLayout: {
        title: 'Choisir un layout et ses éléments',
        description: 'Permet de choisir un type de layout et remplir les différents éléments',
      },
    },
    layouts: {
      0: 'Layout A - 1 vidéo + abonnement',
      1: 'Layout B - 2 éléments + abonnement',
      2: 'Layout C - 3 élements + abonnement',
    },
  },
  detail: {
    all: 'Toutes',
    impactedVideos: 'Vidéos impactées',
    processedAt: 'Traité le',
    errorDetail: 'Détail',
    seeOnYoutube: 'Voir sur YouTube',
    outcomes: {
      created: 'ajouté',
      overwritten: 'remplacé',
      skipped_existing: 'ignoré, déjà présent',
      skipped_too_short: 'ignoré, vidéo trop courte',
      skipped_made_for_kids: 'ignoré, vidéo conçue pour les enfants',
      skipped_aspect_ratio: "ignoré, trop d'éléments pour le format de la vidéo",
      skipped_short: 'ignoré, la vidéo est un Short',
    },
    simulated: "Environnement simulé : aucune modification n'a été appliquée sur YouTube",
    endscreenElements:
      '%{smart_count} élément |||| %{smart_count} éléments - début %{startSecondsBeforeEnd}s avant la fin',
  },
  confirmation: {
    title: 'Confirmation',
    videos: 'Vidéos sélectionnées',
    appliedElements: 'Éléments appliqués',
    details: 'Détails',
    videosWithEndscreen_one: '%{smart_count} vidéo sélectionnée a déjà un endscreen',
    videosWithEndscreen_other: '%{smart_count} vidéos sélectionnées ont déjà un endscreen',
    videosWithInfocards_one: '%{smart_count} vidéo sélectionnée a déjà des infocards',
    videosWithInfocards_other: '%{smart_count} vidéos sélectionnées ont déjà des infocards',
    willOverwrite: 'Elles seront écrasées',
    willSkip: 'Elles seront ignorées',
    copyFromVideo: "Copie de la vidéo '%{videoId}'",
    customEndscreen: 'Layout %{layoutId} - éléments personnalisés',
    customInfocards:
      '%{smart_count} infocard à appliquer |||| %{smart_count} infocards à appliquer',
    operationName: "Nom de l'opération (optionnel)",
    overwriteExistingEndscreen: 'Écraser les endscreens existants',
    overwriteExistingInfocards: 'Écraser les infocards existantes',
    launch: "Lancer l'opération",
    launchConfirmTitle: "Lancer l'opération ?",
    launchConfirm:
      'Cette opération applique directement sur YouTube : %{elements}, sur %{smart_count} vidéo de la chaîne %{channel}. |||| Cette opération applique directement sur YouTube : %{elements}, sur %{smart_count} vidéos de la chaîne %{channel}.',
    launchConfirmOverwrite: 'Les éléments déjà présents sur ces vidéos seront écrasés.',
    launchConfirmSkip: 'Les vidéos qui ont déjà ces éléments seront ignorées.',
    launchConfirmMixed:
      'Écrans de fin existants : %{endscreen}. Infocards existantes : %{infocards}.',
    overwritten: 'écrasés',
    skipped: 'ignorées',
    success: "L'opération de promotion a bien été créée",
    error: "Échec de la création de l'opération",
  },
  infoCards: {
    _title: 'Infocards',
    cardToApply: 'Infocard à appliquer',
    max5Cards: 'Limité à 5 infocards',
    targetNotSet: 'Cible non définie',
    addCard: 'Ajouter une card',
    customMessage: 'Message personnalisé',
    teaserText: "Texte d'accroche",
    teaserStartOffsetSeconds: 'Apparaît à',
    editInfocardTarget: 'Édition de la cible',
    configs: {
      defineCards: {
        title: 'Configurer les infocards',
        description: 'Ajouter une ou plusieurs cartes à appliquer à chaque vidéo sélectionnée.',
      },
      copyInfocard: {
        title: "Copier les infocards d'une vidéo",
        description:
          'Les éléments sélectionnés seront copiés depuis la vidéo sélectionnée ci-dessous',
      },
    },
    types: {
      video: 'Video',
      playlist: 'Playlist',
      channel: 'Chaîne',
      link: 'Lien',
    },
  },
  recap: {
    endscreenTitle: "Aperçu de l'écran de fin",
    copiedFrom: 'Copié depuis la vidéo',
    timing: 'Affiché %{start} s avant la fin, jusqu’à la fin de la vidéo',
    timingWithDuration: 'Affiché %{start} s avant la fin, pendant %{duration} s',
    teaserAuto: 'Moment automatique',
  },
  success: {
    syncChannelVideos: {
      title: 'Synchronisation des vidéos de la chaîne',
      description: '%{smart_count} vidéo synchronisée |||| %{smart_count} vidéos synchronisées',
      noVideoWithoutUploadsPlaylist:
        "Aucune vidéo trouvée : la chaîne n'a ni liste de mises en ligne ni playlist sur YouTube. Cochez « Inclure les vidéos non répertoriées et privées » pour lancer une recherche complète",
      withoutUploadsPlaylist:
        "%{smart_count} vidéo synchronisée depuis les playlists de la chaîne, qui n'a pas de liste de mises en ligne sur YouTube : cochez « Inclure les vidéos non répertoriées et privées » pour toutes les récupérer |||| %{smart_count} vidéos synchronisées depuis les playlists de la chaîne, qui n'a pas de liste de mises en ligne sur YouTube : cochez « Inclure les vidéos non répertoriées et privées » pour toutes les récupérer",
    },
  },
  errors: {
    syncChannelVideos: 'La synchronisation des vidéos a échoué : %{reason}',
  },
  error: {
    syncChannelVideos: {
      title: 'Synchronisation des vidéos de la chaîne',
      description: 'Les vidéos de la chaîne ont bien été synchronisées',
    },
  },
}
